//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { getCurrentUser } from 'aws-amplify/auth';
import SentryWrap from "components/Sentry";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
//  -- Components ---------------------
import { Modal } from '@mui/material';
import DistrictStudentTable from "containers/SuperAdmin/Section/StudentTable";
import SchoolTable from "containers/SuperAdmin/Section/SchoolTable";
import TeacherTable from "containers/SuperAdmin/Section/TeacherTable";
import ClassesTable from "containers/SuperAdmin/Section/ClassTable"
import DistrictsAdminTable from "containers/SuperAdmin/Section/DistrictAdminList";
import { Spin, Tabs } from "antd"
import queryString from 'query-string';

const Wrapper = styled.div`
  height: 100%;
  padding: 20px 0px;
  width: 100%;
`;
 
const VideoContainer = styled.div`
  flex: 1;
  justify-content: center;
  display: flex;
  align-items: center;
  height: 100vh;
  width: 100vw;
`;

const tab_key = {
    teacher:"see_teachers",
    see_teachers:"see_teachers",
    student:"see_students",
    see_students:"see_students",
    parent:"parent",
    see_schools:"see_schools",
    school:"see_schools",
    district_admins:"district_admins",
    district_admins_view:"district_admins_view",
    admin:"district_admins",
    see_districts:"see_districts",
    see_classes:"see_classes",
    see_courses:"see_courses",
    schoology_courses:'schoology_courses'
}




const DistrictDataBrowsers = ({
  currentOrg,
  schools,
  users,
  classes,
}) => {
  const navigate = useNavigate();
  const [userloading, setUserLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("see_schools");
  const location = useLocation();
  function handleTabJump(tabKey, distData) {
    setActiveTab(tabKey);
    setTimeout(() => {
      navigate(`?tab=${tab_key[tabKey] || ''}`);
    }, 500)
  }
  useEffect(() => {
    const search = queryString.parse(location.search);
    if (search && search.tab) {
      if (tab_key[search.tab]) {
        if (activeTab != tab_key[search.tab])
          setActiveTab(tab_key[search.tab])
      }
      else {
        setActiveTab("see_schools");
      }
    } else {
      setActiveTab("see_schools");
    }
  }, [location.search])
  const tabItems = [
    {
      key: "see_schools",
      label: "Schools",
      children: <SchoolTable
        userloading={userloading}
        onTabsJump={handleTabJump}
        active_tab={activeTab}
      />
    },
    {
      key: "see_teachers",
      label: "Teachers",
      children: <TeacherTable
        userloading={userloading}
        onTabsJump={handleTabJump}
        active_tab={activeTab}
      />
    },
    {
      key: "see_students",
      label: "Students",
      children: <DistrictStudentTable
        userloading={userloading}
        onTabsJump={handleTabJump}
        active_tab={activeTab}
      />
    },
    {
      key: "district_admins",
      label: "Placement Admin",
      children: <DistrictsAdminTable
        users={users}
        userloading={userloading}
        active_tab={activeTab}
        from="district_admin"
      />
    },
    {
      key: "district_admins_view",
      label: "District Admins",
      children: <DistrictsAdminTable
        users={users}
        userloading={userloading}
        active_tab={activeTab}
        from="view_only"
        allowAdd={false}
      />
    },
    {
      key: "see_classes",
      label: "Classes",
      children: <ClassesTable
        users={users}
        schools={schools}
        classes={classes}
        userloading={userloading}
        onTabsJump={handleTabJump}
        active_tab={activeTab}
      />
    }
  ].filter(tab => tab.children);

  useEffect(() => {
    async function fetchData() {
      try {
        await getCurrentUser();
      } catch {
        navigate("/");
      }
    }
    fetchData();
  }, []);
  

  useEffect(() => {
  }, [currentOrg]);
  
  const onSwitchTab = (key) => {
    setActiveTab(key)
    setTimeout(() => {
      navigate(`?tab=${tab_key[key] || ''}`);
    }, 500)
  }
  return (
    <SentryWrap>
      <Modal
        open={dataLoading}
      >
        <VideoContainer>
          <Spin size="large" />
        </VideoContainer>
      </Modal>
      <Wrapper className={"adminForm dataBrowserTab"}>
        <Tabs
          activeKey={activeTab}
          onChange={onSwitchTab}
          type="line"
          items={tabItems}
          style={{ padding: '20px' }}
        />
      </Wrapper>
    </SentryWrap>
  );
};


//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = (state) => ({
  classes: state.classes,
  currentOrg: state.currentOrg,
  schools: state.schools,
  users: state.users,
});

export default connect(mapStateToProps, null)(DistrictDataBrowsers);
